import "./App.css";
import { ToastContainer } from "react-toastify";
import Routers from "./components/Routers";
import { CURRENT_VERSION } from "./version";
import { useEffect } from "react";

function App() {
  const APP_VERSION = localStorage.getItem("APP_VERSION");
  useEffect(() => {
    try {
      if (APP_VERSION !== CURRENT_VERSION) {
        console.log("New version available. Reloading...");
        localStorage.setItem("APP_VERSION", CURRENT_VERSION);
        window.location.reload(true);
      }
    } catch (error) {
      console.error("Version check failed", error);
    }
  }, []);
  return (
    <>
      <Routers />
      <ToastContainer />
    </>
  );
}

export default App;
